module.exports = __webpack_public_path__ + "img/personal15.4fabb4ad.png";